import React from 'react';
import { BrandSelect, Col, Form, FormModal, Input, Row, Typography } from 'components';
import { ValidationErrors } from 'constants/validations';
import { useAddItem } from 'pages/admin/items/addItem/useAddItem';
import { AttachmentForm } from './Attachments';

const { Item } = Form;
const { TextArea } = Input;
const { Text } = Typography;

export interface IAddBrandModal {
  modalState: boolean;
  onModalStateChange: (value: boolean) => void;
}

export interface ItemAddFormFieldType {
  itemSKU: string;
  brandId: string;
  description: string;
  file: undefined;
  attachmentTypes: string[];
}

export const AddItemModal: React.FC<IAddBrandModal> = (props) => {
  const { onModalStateChange, modalState } = props;
  const {
    onFinish,
    form,
    onCancel,
    isLoading,
    attachments,
    handleAttachmentChange,
    fileList,
    setFileList,
    attachmentType,
    setAttachmentType,
  } = useAddItem({ onModalStateChange });

  return (
    <FormModal
      form={form}
      title={'Add Item'}
      okText={'Add'}
      open={modalState}
      isLoading={isLoading}
      onCancel={onCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Item
            label={'Item SKU*'}
            name={'itemSKU'}
            rules={[{ required: true, message: ValidationErrors.required('Item SKU') }]}
          >
            <Input size={'large'} />
          </Item>
        </Col>
        <Col span={12}>
          <Item
            label={'Brand*'}
            name={'brandId'}
            rules={[
              {
                required: true,
                message: ValidationErrors.required('Brand'),
              },
            ]}
          >
            <BrandSelect size={'large'} maxTagCount={'responsive'} />
          </Item>
        </Col>
        <Col span={24}>
          <Item label={'Description'} name={'description'}>
            <TextArea style={{ resize: 'none' }} rows={4} size={'large'} />
          </Item>
        </Col>
        <Col span={24} className={'margin-t-20'}>
          <Text style={{ color: '#05796B', fontWeight: 800 }}>Attachments</Text>
        </Col>
        <Col span={24}>
          <AttachmentForm
            attachments={attachments}
            setAttachmentType={setAttachmentType}
            fileList={fileList}
            entity={'ITEM'}
            setAttachments={handleAttachmentChange}
            setFileList={setFileList}
            attachmentType={attachmentType}
          />
        </Col>
        <Col span={24}>
          <Item label={'Additional Notes'} name={'additionalNotes'}>
            <TextArea rows={4} />
          </Item>
        </Col>
      </Row>
    </FormModal>
  );
};
